import { checker } from '../util';


let nextMonth = new Date(new Date().setMonth(new Date().getMonth() + 1)); // 跨年会不会有影响
let expire = nextMonth.getTime();
export default {
    /**
     * 设置 key value
     * @param {object} context - context
     * @param {object} context.data - data
     * @param {string} context.data.key - key
     * @param {any}    context.data.value - value
     * @param {number} context.data.expire - 过期时间. (单位: 毫秒)
     */
    set(context) {
        checker(context);
        context.data.expire = new Date(context.data.expire || expire).getTime();
        //context.data.expire = 10000;
        window['dsBridge'].call('setStorageValue', context.data);
    },
    /**
     * 获取 key 对应的 value
     * @param {object} context - context
     * @param {object} context.data - data
     * @param {string} context.data.key - key
     *
     * @return {any}
     */
    get(context) {
        checker(context);
        let result = window['dsBridge'].call('getStorageValue', context.data.key);
        if (result) {
            delete result.expire;
        }
        return result;
    },

    /**
     * 删除 key 对应的 value
     * @param {object} context - context
     * @param {object} context.data - data
     * @param {string} context.data.key - key
     * @param context
     */
    remove(context) {
        checker(context);
        window['dsBridge'].call('removeStorage', context.data.key);
    },

    /**
     * 删除 key 对应的 value
     * @param {object} context - context
     * @param {object} context.data - data
     * @param {string} context.data.key - key
     * @param context
     */
    delete(context) {
        checker(context);
        window['dsBridge'].call('removeStorage', context.data.key);
    },

    /**
     * @description 清除所有 慎用，会把app 存储没有 domain 概念会导致全部清除
     */
    clear() {
        window['dsBridge'].call('clearStorage', '');
    },
};
